import templateUrl from './edit-division-onboarding-policy-modal.html'

export const EditDivisionOnboardingPolicyModalComponent = {
    bindings: {
        resolve: "<",
        dismiss: "&",
        close: "&"
    },
    templateUrl,
    controller: EditDivisionOnboardingPolicyModalController,
    controllerAs: "vm"
}

function EditDivisionOnboardingPolicyModalController(onboardingPolicyService, utilityService) {
    'ngInject'
    const vm = this;
    vm.$onInit = onInit;
    vm.onSave = onSave;

    function onInit() {
        vm.onboardingPolicy = vm.resolve.onboardingPolicy;
        vm.division = vm.resolve.division;
    }

    function onSave() {
        const request = mapOnboardingPolicyToCreateRequest(vm.onboardingPolicy);
        const saved = onboardingPolicyService.defineDivisionOnboardingPolicy(vm.division.DivisionID, request);
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(saved, "Save failed"));

        saved
            .then(function (onboardingPolicy) {
                alert("Onboarding policy has been saved to the division successfully");
                vm.close({ $value: onboardingPolicy });
            });
    }

    function mapOnboardingPolicyToCreateRequest(onboardingPolicy) {
        return {
            EnableSelfSignUp: onboardingPolicy.EnableSelfSignUp,
            ContactEmails: onboardingPolicy.ContactEmails,
            ApplicationStatuses: onboardingPolicy.ApplicationStatuses.map(function (status) {
                return {
                    Name: status.Name,
                    StatusType: status.StatusType
                };
            }),
            ReferenceFields: onboardingPolicy.ReferenceFields.map(function (field) {
                return {
                    Name: field.Name,
                    RequiredAtStatus: onboardingPolicy.ApplicationStatuses.reduce(function (index, status, i) {
                        return index !== null ? index : status === field.RequiredAtStatus ? i : null;
                    }, null),
                    IsSensitive: field.IsSensitive,
                    InputMask: field.InputMask,
                    ValueType: field.ValueType,
                    ShowInGrid: field.ShowInGrid
                };
            }),
            OnboardingDocumentGroups: onboardingPolicy.OnboardingDocumentGroups.map(function (group) {
                return {
                    Name: group.Name,
                    RequirementsFileUpload: group.RequirementsFileUpload
                };
            }),
            OnboardingDocuments: onboardingPolicy.OnboardingDocuments.map(function (document) {
                return {
                    Name: document.Name,
                    Description: document.Description,
                    DocumentGroup: onboardingPolicy.OnboardingDocumentGroups.reduce(function (index, group, i) {
                        return index !== null ? index : group === document.DocumentGroup ? i : null;
                    }, null),
                    IsRequired: document.IsRequired,
                    UseImageCropper: document.UseImageCropper,
                    AllowedFileTypes: document.AllowedFileTypes,
                    BlankFormUpload: document.BlankFormUpload
                };
            })
        }
    }
}
